const actionsProviders = [];
let shellActions;
export const registerActionsProvider = (provider) => {
    actionsProviders.push(provider);
};
export const getActionsProviders = () => actionsProviders;
/**
 * Creates a set of action functions for a specific app instance
 */
export const createActionsForAppInstance = (appMetaData, instanceId, defaultActionsProvider) => {
    let actions = defaultActionsProvider(appMetaData, instanceId);
    // Add all registered actions providers
    for (const ap of actionsProviders) {
        actions = {
            ...actions,
            ...ap(appMetaData, instanceId)
        };
    }
    return actions;
};
export const setShellActions = (actions) => {
    shellActions = actions;
};
export const getShellActions = () => {
    if (typeof shellActions !== 'object') {
        throw new Error(`x-runtime has not been initialised. Please initialise it using the initRuntime function`);
    }
    return shellActions;
};
export const resetActionsRegistry = () => {
    shellActions = undefined;
    actionsProviders.splice(0, actionsProviders.length);
};
//# sourceMappingURL=core.js.map